// @ts-nocheck


import { navigate } from '../../../lib/routerAdapter';

import Button from 'antd/lib/button';
import notification from 'antd/lib/notification';

import moment from 'moment';
import React, { Component } from 'react';
import styled from 'styled-components';
import { Form } from '../../../components';
import { DatePicker } from '../../../components/ant/DatePicker';
import CancelButton from '../../../components/CancelButton';

import { InputNumber } from '../../../components/inputs';

import { Footer, Header, Panel, Section } from '../../../components/layout';
import Breadcrumbs, { Crumb } from '../../../components/layout/Breadcrumbs';
import Grid, { GridItem } from '../../../components/layout/Grid';
import { notificationLoading } from '../../../components/Notifications';
import { osagoMultiplier } from '../../../lib/api';
import { disabledDateMin, formatDateTimeToISOString, getValueObject, goBack } from '../../../lib/helpers';











const StyledPanel = styled(Panel).withConfig({ displayName: "OsagoKprMultiplierForm__StyledPanel", componentId: "sc-1xb2sdx-0" })(["padding-top:0;"]);


const SectionContent = styled.div.withConfig({ displayName: "OsagoKprMultiplierForm__SectionContent", componentId: "sc-1xb2sdx-1" })(["padding:16px;"]);


const Required = styled.span.withConfig({ displayName: "OsagoKprMultiplierForm__Required", componentId: "sc-1xb2sdx-2" })(["color:red;position:relative;top:-3px;right:-2px;font-size:12px;"]);







export default class OsagoKprMultiplierForm extends Component {
  state = {
    osagoKprMultiplier: null
  };

  onSubmit = async (values) => {
    const { osagoKprMultiplierId } = this.props;
    try {
      notificationLoading({
        message: 'Сохранение...',
        key: 'saving'
      });
      if (osagoKprMultiplierId) {
        await osagoMultiplier.updateOsagoKprMultiplier(values);
      } else {
        await osagoMultiplier.addOsagoKprMultiplier(values);
      }
      navigate('/admin/osago-multiplier/kpr');
    } catch (error) {
      notification.error({
        message: 'Ошибка',
        description: error.message
      });
    } finally {
      notification.destroy('saving');
    }
  };

  async componentDidMount() {
    let osagoKprMultiplierId = parseInt(this.props.osagoKprMultiplierId, 10);
    try {
      if (osagoKprMultiplierId) {
        try {
          const osagoKprMultiplier = await osagoMultiplier.getOsagoKprMultiplier(
            osagoKprMultiplierId
          );
          this.setState({ osagoKprMultiplier });
        } catch (error) {
          notification.error({
            message: 'Ошибка',
            description: error.message
          });
        }
      } else {
        let osagoKprMultiplier = {};
        osagoKprMultiplier.startDate = getValueObject(
          this.props,
          'location.state.startDate'
        );
        this.setState({ osagoKprMultiplier });
      }
    } catch (error) {
      notification.error({
        message: 'Ошибка',
        description: error.message
      });
    }
  }

  onCancel = () => goBack('/admin/osago-multiplier/kpr');

  render() {
    const { osagoKprMultiplierId } = this.props;
    const { osagoKprMultiplier } = this.state;
    return (
      <>
        <Header
          left={
          <Breadcrumbs>
              <Crumb to="/">Главная</Crumb>
              <Crumb to="/admin/osago-multiplier/kpr">
                КПР коэффициенты ОСАГО
              </Crumb>
              {osagoKprMultiplierId ?
            <Crumb
              to={`/admin/osago-multiplier/kpr/edit/${osagoKprMultiplierId}`}>

                  КПР коэффициенты ОСАГО №{osagoKprMultiplierId}
                </Crumb> :

            <Crumb to={`/admin/osago-multiplier/kpr/new`}>
                  Новые КПР коэффициенты ОСАГО
                </Crumb>
            }
            </Breadcrumbs>
          } />

        <StyledPanel>
          <h1>
            {osagoKprMultiplierId ?
            `Редактируем запись №${osagoKprMultiplierId}` :
            `Новая запись`}
          </h1>
        </StyledPanel>
        <Form initialValues={osagoKprMultiplier} onSubmit={this.onSubmit}>
          {(FormField, formikProps) => {
            const {
              handleSubmit,
              handleBlur,
              setFieldValue,
              dirty,
              isSubmitting,
              values
            } = formikProps;
            return (
              <form onSubmit={handleSubmit}>
                <Section>
                  <SectionContent>
                    <Grid cols={2}>
                      <GridItem span={1}>
                        Прицепы к легковым автомобилям, принадлежащим
                        юридическим лицам, к мотоциклам и мотороллерам
                        <Required>*</Required>
                      </GridItem>
                      <GridItem span={1}>
                        <FormField
                          required
                          hasFeedback={false}
                          name="trailerCar"
                          fast>

                          {({ name, value }) =>
                          <InputNumber
                            name={name}
                            min={0.01}
                            value={value}
                            onChange={(count) =>
                            setFieldValue(name, count)
                            }
                            onBlur={handleBlur} />

                          }
                        </FormField>
                      </GridItem>
                    </Grid>
                    <Grid cols={2}>
                      <GridItem span={1}>
                        Прицепы к грузовым автомобилям с разрешенной
                        максимальной массой 16 тонн и менее, полуприцепы,
                        прицепы-роспуски
                        <Required>*</Required>
                      </GridItem>
                      <GridItem span={1}>
                        <FormField
                          required
                          hasFeedback={false}
                          name="trailerTruckMax16"
                          fast>

                          {({ name, value }) =>
                          <InputNumber
                            name={name}
                            min={0.01}
                            value={value}
                            onChange={(count) =>
                            setFieldValue(name, count)
                            }
                            onBlur={handleBlur} />

                          }
                        </FormField>
                      </GridItem>
                    </Grid>
                    <Grid cols={2}>
                      <GridItem span={1}>
                        Прицепы к грузовым автомобилям с разрешенной
                        максимальной массой более 16 тонн, полуприцепы,
                        прицепы-роспуски
                        <Required>*</Required>
                      </GridItem>
                      <GridItem span={1}>
                        <FormField
                          required
                          hasFeedback={false}
                          name="trailerTruckMin16"
                          fast>

                          {({ name, value }) =>
                          <InputNumber
                            name={name}
                            min={0.01}
                            value={value}
                            onChange={(count) =>
                            setFieldValue(name, count)
                            }
                            onBlur={handleBlur} />

                          }
                        </FormField>
                      </GridItem>
                    </Grid>
                    <Grid cols={2}>
                      <GridItem span={1}>
                        Прицепы к тракторам, самоходным дорожно-строительным и
                        иным машинам, за исключением транспортных средств, не
                        имеющих колесных движителей
                        <Required>*</Required>
                      </GridItem>
                      <GridItem span={1}>
                        <FormField
                          required
                          hasFeedback={false}
                          name="trailerTractor"
                          fast>

                          {({ name, value }) =>
                          <InputNumber
                            name={name}
                            min={0.01}
                            value={value}
                            onChange={(count) =>
                            setFieldValue(name, count)
                            }
                            onBlur={handleBlur} />

                          }
                        </FormField>
                      </GridItem>
                    </Grid>
                    <Grid cols={2}>
                      <GridItem span={1}>
                        Прицепы к другим типам (категориям) и назначению ТС
                        <Required>*</Required>
                      </GridItem>
                      <GridItem span={1}>
                        <FormField
                          required
                          hasFeedback={false}
                          name="trailerOther"
                          fast>

                          {({ name, value }) =>
                          <InputNumber
                            name={name}
                            min={0.01}
                            value={value}
                            onChange={(count) =>
                            setFieldValue(name, count)
                            }
                            onBlur={handleBlur} />

                          }
                        </FormField>
                      </GridItem>
                    </Grid>
                    <Grid>
                      <GridItem>
                        Дата начала
                        <Required>*</Required>
                      </GridItem>
                      <GridItem>
                        <FormField
                          required
                          hasFeedback={false}
                          name="startDate"
                          fast
                          style={{ width: '140px' }}>

                          {({ name, value }) =>
                          <DatePicker
                            format="DD.MM.YYYY"
                            value={value ? moment.utc(value) : value}
                            onChange={(value, dateString) => {
                              setFieldValue(
                                name,
                                formatDateTimeToISOString(value, dateString)
                              );
                              setFieldValue('endDate', undefined);
                            }} />

                          }
                        </FormField>
                      </GridItem>
                    </Grid>
                    <Grid>
                      <GridItem>Дата окончания</GridItem>
                      <GridItem>
                        <FormField
                          style={{ width: '140px' }}
                          hasFeedback={false}
                          name="endDate">

                          {({ name, value }) =>
                          <DatePicker
                            format="DD.MM.YYYY"
                            value={value ? moment.utc(value) : value}
                            disabled={values.startDate ? false : true}
                            disabledDate={(currentDate) =>
                            disabledDateMin(
                              currentDate,
                              moment(values.startDate)
                            )
                            }
                            onChange={(value, dateString) => {
                              setFieldValue(
                                name,
                                formatDateTimeToISOString(value, dateString)
                              );
                            }} />

                          }
                        </FormField>
                      </GridItem>
                    </Grid>
                  </SectionContent>
                </Section>
                <Footer>
                  <Button
                    disabled={isSubmitting}
                    loading={isSubmitting}
                    type="primary"
                    htmlType="submit"
                    data-cy="save">

                    Сохранить
                  </Button>
                  <CancelButton dirty={dirty} onClick={this.onCancel}>
                    Отменить
                  </CancelButton>
                </Footer>
              </form>);

          }}
        </Form>
      </>);

  }
}
